<template>
  <div class="box">
  <b-container fluid>
    <b-row class="m-text-deep">
      <b-col md="5">
        <h4 class="mt-2">Choose State: </h4>
        <b-select v-model = "selectedState"
                  data-test="geo-select-state"
                  class="ttt">
          <option v-for="item in state"
                  :value = "item.code">
            {{item.name}}</option>
        </b-select>
        <h4 class="mt-2">{{subTitle}}</h4>

        <div class="m-select-spinner" v-show="substate.length === 0">
          <div class="m-spinner "></div>
        </div>
        <b-select multiple
                  v-model = "selectedSubtitle"
                  :select-size="11"
                  data-test="geo-select-subState"
                  class="demo-select">
          <option v-for="item in substate"
                  :value = "item">
            {{item.text}}</option>
        </b-select>
      </b-col>
      <b-col md="2" class="m-select-btn-box">
        <b-btn class="m-select-btn"
               data-test="geo-select-add"
               size="sm"
               @click="addGeos()" style="margin-top: 16px">
          Add</b-btn>
        <b-btn class="m-select-btn"
               data-test="geo-select-remove"
               size="sm"
               @click="deleteGeos()">
          Remove</b-btn>
        <b-btn class="m-select-btn"
               data-test="geo-select-removeAll"
               @click="cleanGeos()"
               size="sm">
          Remove All</b-btn>
      </b-col>
      <b-col md="5" rows="2">
        <h4 class="mt-2">Your Target Audience:</h4>
        <b-select v-model = "unSelectedGeos"
                  :select-size="16"
                  class="demo-select"
                  multiple >
          <option v-for="item in selectedGeos"
                  :value="item.GeoKeyCode" :class="{'demos-column':item.type === 'column' }" class="demos-value">
            {{item.GeoKeyDesc}}
          </option>
        </b-select>
      </b-col>
    </b-row>
  </b-container>
</div>
</template>

<script>
  import _ from 'lodash'
  export default {
    props: {
      geoType: {
        type: Number,
        default: 1
      },
      changeGeoType: {
        type: Number,
        default: 1
      }
    },
    components: {
    },
    data () {
      return {
        selectedState: 'AL',
        selectedSubtitle: [],
        unSelectedGeos: []
      }
    },
    computed: {
      listType () {
        return this.$store.state.order.ListType
      },
      geos () {
        return this.$store.state.geo.geos
      },
      selectedGeos () {
        return _.filter(this.$store.getters['order/geoItems'], {GeoType: this.geoType})
      },
      state () {
        return this.$store.state.geo.states
      },
      substate () {
        if (this.selectedState !== '') {
          if (!(this.geoType in this.geos) || !(this.selectedState in this.geos[this.geoType]) || this.geos[this.geoType][this.selectedState].length === 0) {
            this.getGeos()
            return []
          } else {
            return this.geos[this.geoType][this.selectedState]
          }
        } else {
          return []
        }
      },
      subTitle () {
        if (this.geoType === 3) {
          return 'Choose Counties:'
        }
        if (this.geoType === 10) {
          return 'Choose Area(s):'
        }
        if (this.geoType === 22) {
          return 'Choose District(s):'
        }
        if (this.geoType === 4) {
          return 'Choose Cities:'
        }
      },
      datasource () {
        return this.$store.getters['config/datasource']
      }
    },
    created () {
      this.$store.dispatch('geo/getStates')
    },
    methods: {
      getGeos () {
        if (this.geoType === 3) {
          this.$http.post('PlaceOrder.aspx/GetCountiesByState', {
            statecode: this.selectedState
          }).then(resp => {
            let data = resp.body.d.DataSource
            for (let item of data) {
              item.GeoKeyCode = item.CountyCode
              item.GeoKeyDesc = item.CountyName + '(' + item.StateCode + ')'
              item.text = item.CountyName
              item.ConutryCode = 'US'
              if (this.datasource.isInfoUSACounty) {
                item.CountyFips = `${item.CountyName}_${this.selectedState}`
              }
            }
            this.commitData(data)
          })
        } else if (this.geoType === 10) {
          this.$http.post('PlaceOrder.aspx/SearchAreas', {
            state: this.selectedState,
            listType: this.listType
          }).then(resp => {
            let data = resp.body.d.DataSource
            for (let item of data) {
              item.GeoKeyCode = item.Code
              item.GeoKeyDesc = `${item.DisplayName}(${this.selectedState})`
              item.text = item.DisplayName
            }
            this.commitData(data)
          })
        } else if (this.geoType === 22) {
          this.$http.post('PlaceOrder.aspx/GetDistrictsByState', {
            statecode: this.selectedState
          }).then(resp => {
            let data = resp.body.d.DataSource
            for (let item of data) {
              item.GeoKeyCode = item.Code
              item.CityName = item.Name
              item.GeoKeyDesc = `${item.Name}(${this.selectedState})`
              item.text = item.Name
            }
            this.commitData(data)
          })
        } else if (this.geoType === 4) {
          if (this.$store.state.geo.isInitCitiesByState) {
            return false
          }
          this.$store.commit('geo/saveKey', ['isInitCitiesByState', true])
          this.$http.post('PlaceOrder.aspx/GetCitiesByState', {
            statecode: this.selectedState
          }).then(resp => {
            let data = resp.body.d.DataSource
            for (let item of data) {
              item.GeoKeyCode = item.CityName + ':' + item.StateCode
              item.GeoKeyDesc = `${item.CityName}(${this.selectedState})`
              item.text = item.CityName
            }
            this.commitData(data)
            this.$store.commit('geo/saveKey', ['isInitCitiesByState', false])
          }, resp => {
            this.$store.commit('geo/saveKey', ['isInitCitiesByState', false])
          })
        }
      },
      addGeos () {
        this.$store.dispatch('order/changeGeoType', this.changeGeoType)
        for (let item of this.selectedSubtitle) {
          item.GeoType = this.geoType
          this.$store.commit('order/addGeo', item)
        }
      },
      cleanGeos () {
        this.$store.commit('order/cleanGeo', this.geoType)
      },
      deleteGeos () {
        for (let item of this.unSelectedGeos) {
          this.$store.commit('order/deleteGeo', item)
        }
      },
      commitData (data) {
        this.$store.commit('geo/saveGeos', {
          geoType: this.geoType,
          stateCode: this.selectedState,
          data: data
        })
      }
    },
    watch: {
    }
  }
</script>

<style scoped lang="scss">
  .select-btn{
    margin-bottom: 8px;
  }
  .demos-column.demos-value {
    color: $color-black;
    margin-left: 0;
    font-size: 0.9em;
  }
  .demos-value {
    margin-left: 16px;
  }
  .select-demo-col{
    padding: 0 8px;
  }
/*
  .box {
    border: 1px solid $color-border;
    border-radius: 8px;
    background-color: $color-background;
    padding:10px 10px 0px 10px;
    width: 100%;
    margin-bottom:10px;
  }
  */
</style>



// WEBPACK FOOTER //
// src/components/geo/MGeoSelect.vue